import { defineMessages } from 'react-intl';

export const messages: {
	tabsHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tabsBody: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tabsBodyLine1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tabsBodyLine2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tabsBodyLine3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tabsSecondaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tabsPrimaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	actionsHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	actionsBody: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	actionsGotIt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	progressIndicator: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	tabsHeading: {
		defaultMessage: 'All at a glance',
		description: 'Heading for status page details tabs spotlight step 1',
		id: 'status-page.details.tabs.spotlight.heading',
	},
	tabsBody: {
		defaultMessage:
			'Review your status page, target audience, and post real-time incident updates, all from a single place.',
		description: 'Body for status page details tabs spotlight step 1',
		id: 'status-page.details.tabs.spotlight.body',
	},
	tabsBodyLine1: {
		defaultMessage: 'Review your status page, target',
		description: 'Body line 1 for status page details tabs spotlight step 1',
		id: 'status-page.details.tabs.spotlight.body.line1',
	},
	tabsBodyLine2: {
		defaultMessage: 'audience, and post real-time incident',
		description: 'Body line 2 for status page details tabs spotlight step 1',
		id: 'status-page.details.tabs.spotlight.body.line2',
	},
	tabsBodyLine3: {
		defaultMessage: 'updates, all from a single place.',
		description: 'Body line 3 for status page details tabs spotlight step 1',
		id: 'status-page.details.tabs.spotlight.body.line3',
	},
	tabsSecondaryAction: {
		defaultMessage: 'Dismiss',
		description: 'Secondary action for status page details spotlight',
		id: 'status-page.details.tabs.spotlight.action',
	},
	tabsPrimaryAction: {
		defaultMessage: 'Next',
		description: 'Primary action for status page details tabs spotlight step 1',
		id: 'status-page.details.tabs.spotlight.primary-action',
	},
	actionsHeading: {
		defaultMessage: 'Update and manage',
		description: 'Heading for status page details actions spotlight step 2',
		id: 'status-page.details.actions.spotlight.heading',
	},
	actionsBody: {
		defaultMessage:
			'Easily manage your status page, edit details and post updates to keep your audience informed.',
		description: 'Body for status page details actions spotlight step 2',
		id: 'status-page.details.actions.spotlight.body',
	},
	actionsGotIt: {
		defaultMessage: 'Ok, got it',
		description: 'Primary action for final step of status page details spotlight',
		id: 'status-page.details.actions.spotlight.got-it',
	},
	progressIndicator: {
		defaultMessage: '{currentStep}/{totalSteps}',
		description: 'Progress indicator for spotlight steps',
		id: 'statuspage.actions-spotlight.progress',
	},
});
